import React from "react";
import { AsideMenuItem } from "./AsideMenuItem";

export function AsideMenuDocs() {
  return (
    <>
      <div className="menu-item">
        <h4 className="menu-content text-muted mb-0 fs-6 fw-bold text-uppercase">
          Help Centre
        </h4>
      </div>
      <AsideMenuItem to="/help/getting-started" title="Getting Started" />
      <AsideMenuItem to="/help/steps-guide" title="The 24 Steps" />
      <AsideMenuItem to="/help/ai-features" title="AI Features" />
      <AsideMenuItem to="/help/scoring" title="Scoring" />
      <AsideMenuItem to="/help/faq" title="FAQ" />
    </>
  );
}
